import { render, staticRenderFns } from "./BpuTemplate.vue?vue&type=template&id=3e0ef102&scoped=true"
import script from "./BpuTemplate.vue?vue&type=script&lang=js"
export * from "./BpuTemplate.vue?vue&type=script&lang=js"
import style0 from "./BpuTemplate.vue?vue&type=style&index=0&id=3e0ef102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ef102",
  null
  
)

export default component.exports